export const LIGHT = 'light'
export const DARK = 'dark'

const useTheme = () => {
  const modeTheme = localStorage.getItem('theme')
  document.documentElement.setAttribute('data-theme', modeTheme)
  return [modeTheme, setThemeState]
}

const setThemeState = (modeTheme) => {
  document.documentElement.setAttribute('data-theme', modeTheme)
  localStorage.setItem('theme', modeTheme)
}

export { useTheme }
